import { Button, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import AntIcon from "../../../../../../common/components/icons/AntIcon";

type Props = {
  link: string;
};

export const ShowMoreButton = ({ link }: Props) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t("common.showMore")}>
      <Button type="text" target="_blank" icon={<AntIcon style={{ fontSize: 13 }} type="export" />} href={link} />
    </Tooltip>
  );
};
